module.exports = __webpack_public_path__ + "static/media/corvette.b2d99ed2.jpg";